<template>
  <!-- 打卡账号管理 -->
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加账号')">添加</el-button>
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteGroup">批量删除</el-button>
    </div>
    <!-- 筛选 -->
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="账号：" prop="username">
        <el-input v-model="screenForm.username" />
      </el-form-item>
      <el-form-item label="真实姓名：" prop="name">
        <el-input v-model="screenForm.name" />
      </el-form-item>
      <el-form-item label="联系方式：" prop="contact">
        <el-input v-model="screenForm.contact" />
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData"> 筛选 </el-button>
    </el-form>
    <!-- 列表 -->
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="index" label="#" width="50" /> -->
        <el-table-column type="selection" width="50" />
        <el-table-column prop="username" label="账号" />
        <el-table-column label="头像" width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.avator" style="width: 70px; height: 70px; border-radius: 8px" @click="previewImage(scope.row.avator)" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="真实姓名" />
        <el-table-column prop="contact" label="联系方式" />
        <el-table-column label="所在公司">
          <template slot-scope="scope">
            <div v-if="scope.row.company">
              <div>{{ scope.row.company.companyName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="zhiwei" label="职位" />
        <el-table-column label="账号状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0" style="color: #67c23a">正常</div>
            <div v-else-if="scope.row.status === 1" style="color: #e6a23c">已禁用</div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openDakaSite(scope.row.isOk, scope.row)">
              {{ scope.row.isOk ? '换绑打卡地址' : '绑定打卡地址' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!-- 添加对话框 -->
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" width="800px" :visible.sync="showDialog" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" auto :rules="rules" :model="form" label-width="80px">
        <el-form-item label-width="100px" prop="companyId" label="打卡账号：">
          <el-select
            v-model="form.companyId"
            filterable
            remote
            clearable
            placeholder="请输入员工打卡账号"
            :remote-method="getSearchCompanyByName"
            :loading="loading"
            @clear="form.companyId = null"
          >
            <el-option v-for="item in companyOpt" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <i v-show="searching" class="el-icon-loading" style="margin-left: 10px" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
    <!-- 绑定打卡对话框 -->
    <el-dialog :title="dakaTitle" width="800px" :visible.sync="showDialogDaka" @close="resetFormDaka">
      <el-form ref="dakaForm" label-position="left" auto :rules="rules" :model="dakaForm" label-width="80px">
        <el-form-item label-width="100px" prop="dakaModel" label="打卡模板：">
          <el-select v-model="dakaForm.dakaModel" clearable placeholder="请选择打卡模板" @change="changeDakaModel">
            <el-option v-for="item in modelList" :key="item.punchSettingId" :label="item.name" :value="item.punchSettingId" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialogDaka = false">取 消</el-button>
        <el-button type="primary" @click="dakaSubmit">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'
import md5 from 'js-md5' // 引入Md5加密
import { deepClone } from '@/utils'
export default {
  mixins: [pagination],
  data() {
    return {
      authCount: {
        count: 0,
        loading: true
      },
      screenForm: {
        username: '',
        name: '',
        contact: ''
      },
      tableData: [],
      loading: true,
      showDialog: false,
      dialogTitle: '',
      form: {
        companyId: null
      },
      rules: {
        companyId: [{ required: true, message: '请选择企业账号', trigger: 'change' }]
      },
      dakaForm: {
        dakaModel: ''
      },
      companyOpt: [],
      searching: false,
      tableH: 0,
      ids: [], // 批量选中的账号组
      showDialogDaka: false,
      dakaTitle: '',
      modelList: [], // 模板数组
      punchSettingId: ''
    }
  },
  mounted() {
    this.getTableList() // 获取企业打卡管理列表
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    // 刷新
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
          this.authCount.loading = false
        })
        .catch(() => {})
    },
    // 筛选
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
          this.authCount.loading = false
        })
        .catch(() => {})
    },
    // 批量选中
    handleSelectionChange(e) {
      this.ids = e.map((item) => item.id)
      console.log(this.ids)
    },
    // 批量删除
    deleteGroup() {
      if (!this.ids.length) return this.$message.info('当前无选中项哦！')
      this.$api.clockIn
        .getDeleteInfo({ ids: this.ids.join(',') })
        .then((res) => {
          this.$message.success('操作成功')
          this.getTableList() // 获取企业打卡管理列表
        })
        .catch((e) => {
          this.$message.error(e)
        })
    },
    // 获取企业打卡管理列表
    getTableList() {
      this.loading = true
      return this.$api.clockIn
        .getPunchAccountList(this.page)
        .then((res) => {
          console.log(res)
          this.tableData = res.records
          if (res.records.length == 0) return (this.loading = false)
          this.total = res.total
          const ids = this.tableData
            .filter((item) => item.companyId)
            .map((item) => item.companyId)
            .join(',')
          this.getFindCompanyByIds({ ids }) // 所在公司
          this.getCompanyList({ ids }) // 账号管理ids接口
        })
        .catch((e) => {})
    },
    // 账号管理ids接口
    getCompanyList(data) {
      this.$api.clockIn
        .getPunchAccountIds(data)
        .then((res) => {
          const arr = Object.keys(res)
          if (arr.length == 0) return (this.loading = false)
          console.log(res)
          const companyList = res
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyId]
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
          console.log(this.tableData)
          this.loading = false
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    // 所在公司
    getFindCompanyByIds(data) {
      this.$api.clockIn
        .getFindCompanyByIds(data)
        .then((res) => {
          console.log(res)
          const arr = Object.keys(res)
          if (arr.length == 0) return (this.loading = false)
          const companyList = res
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyId]
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
          console.log(this.tableData)
          this.loading = false
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    // 打开添加/编辑账号弹窗
    openDialog(title, row) {
      this.dialogTitle = title
      this.showDialog = true
      row &&
        this.$nextTick(() => {
          // const { username, avator, contact, companyId, email, status, zhiwei, auth, id, name, reason } = row
          const { username, avator, name, contact, companyId, zhiwei, status, id } = row
          this.form.username = username
          this.form.avator = avator
          this.form.name = name
          this.form.contact = contact
          this.form.companyId = companyId
          this.form.zhiwei = zhiwei
          this.form.status = status
          this.form.id = id
          // this.form.email = email
          // this.form.auth = auth
          // this.form.reason = reason
          this.companyOpt = [{ value: row.companyId, label: row.company.companyName }]
        })
    },
    // 打开绑定打卡模板弹窗
    openDakaSite(isOk, row) {
      const title = isOk ? '换绑打卡地址' : '绑定打卡地址'
      this.showDialogDaka = true
      this.dakaTitle = title
      this.companyAccountId = row.id
      this.getDakaModel(row.punchSettingId) // 获取打卡模板列表
    },
    // 关闭绑定打卡模板弹窗
    resetFormDaka() {
      this.$refs.dakaForm.resetFields()
      this.dakaForm.dakaModel = ''
    },
    // 打卡模板下拉框改变时
    changeDakaModel(e) {
      this.punchSettingId = e
    },
    // 获取打卡模板列表
    getDakaModel(punchSettingId) {
      return this.$api.clockIn
        .punchTemplate()
        .then((res) => {
          console.log(res)
          this.modelList = res
          if (res.length == 0) return
          this.modelList.forEach((item) => {
            if (item.punchSettingId == punchSettingId) {
              this.dakaForm.dakaModel = item.name
            }
          })
          // this.modelList.forEach((item, index) => {
          //   let id = item.punchSettingId
          //   this.getCompanyList({ id }, index) // 账号管理ids接口
          // })
        })
        .catch((e) => {
          console.log(e)
        })
    },
    // 绑定打卡(提交)
    dakaSubmit() {
      if (this.dakaTitle == '绑定打卡地址') {
        const params = {
          companyAccountId: this.companyAccountId,
          punchSettingId: this.punchSettingId
        }
        this.$api.clockIn
          .getPunchAccountBindPunch(params)
          .then((res) => {
            console.log(res)
            this.$message.success('操作成功')
            this.getTableList() // 获取企业打卡管理列表
            this.showDialogDaka = false
          })
          .catch((e) => {
            console.log(e)
          })
      } else {
        const params = {
          companyAccountId: this.companyAccountId,
          punchSettingId: this.punchSettingId
        }
        this.$api.clockIn
          .getPunchAccountChangePunch(params)
          .then((res) => {
            console.log(res)
            this.$message.success('操作成功')
            this.getTableList() // 获取企业打卡管理列表
            this.showDialogDaka = false
          })
          .catch((e) => {
            console.log(e)
          })
      }
    },
    // 搜索公司
    getSearchCompanyByName(username) {
      this.searching = true
      this.companyOpt = []
      this.$api.clockIn
        .getSearchCompanyByName({ username })
        .then((res) => {
          console.log(res)
          this.companyOpt[0] = {
            value: res.companyAccountId,
            label: res.name
          }
          console.log(this.companyOpt)
          // this.companyOpt = res.map((item) => {
          //   return {
          //     value: item.id,
          //     label: item.username
          //   }
          // })
          this.searching = false
        })
        .catch((e) => {
          console.log(e)
        })
    },
    // 提交
    handleSubmit() {
      if (!this.validateForm()) return
      // const form = deepClone(this.form)
      // if (form.password) {
      //   form.password = md5(form.password)
      // } else {
      //   delete form.password
      // }
      if (this.dialogTitle === '添加账号') {
        const params = {
          companyAccountId: this.companyOpt[0].value
        }
        this.loading = true
        this.$api.clockIn
          .getSaveInfo(params)
          .then((res) => {
            this.showDialog = false
            this.getTableList() // 获取企业打卡管理列表
            this.$message.success('操作成功')
          })
          .catch((e) => {
            this.loading = false
            this.$message.error(e)
          })
      } else {
        console.log('edit')
        console.log(this.form)
        try {
          this.$api.clockIn
            .getUpdateInfo(form)
            .then((res) => {
              this.showDialog = false
              this.getTableList() // 获取企业打卡管理列表
              this.$message.success('操作成功')
            })
            .catch((e) => {
              this.loading = false
              this.$message.error(e)
            })
        } catch (error) {
          console.log(error)
        }
      }
    },
    // 关闭弹窗
    resetForm() {
      this.$refs.form.resetFields()
      this.companyOpt = []
    },
    // 删除账号
    // handleDeleteAccount(row) {
    //   this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       this.loading = true
    //       this.$api.clockIn
    //         .getDeleteInfo({ ids: row.id })
    //         .then((res) => {
    //           this.$message({
    //             type: 'success',
    //             message: res
    //           })
    //           this.getTableList() // 获取企业打卡管理列表
    //         })
    //         .catch((e) => {
    //           this.$message({
    //             type: 'info',
    //             message: e
    //           })
    //         })
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消删除'
    //       })
    //     })
    // },
    // 上传图片成功
    handleAvatarSuccess(res) {
      this.form.avator = res.data
      this.$refs.form.clearValidate('avator')
    },
    // 上传头像是否符合
    beforeAvatarUpload(file) {
      const isImg = /image/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isImg && isLt2M
    },
    // 表单验证
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
